module.exports = __webpack_public_path__ + "static/media/exhibition.89eb171d.svg";